import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import DigitalContactCard from "./pages/DigitalContactCard";
import "./styles/App.css";

const AppWrapper = () => {
  const location = useLocation();
  const hideHeaderRoutes = ["/digitalcard"]; // Add more routes if needed

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <div className="app">
      {!shouldHideHeader && <Header />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/digitalcard" element={<DigitalContactCard />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
